import * as React from 'react';

export const CalendarEdit = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.24414 9.66406C3.24414 9.24985 3.57993 8.91406 3.99414 8.91406H20.1878C20.602 8.91406 20.9378 9.24985 20.9378 9.66406C20.9378 10.0783 20.602 10.4141 20.1878 10.4141H3.99414C3.57993 10.4141 3.24414 10.0783 3.24414 9.66406Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.728 2.25C16.1422 2.25 16.478 2.58579 16.478 3V5.96164C16.478 6.37585 16.1422 6.71164 15.728 6.71164C15.3138 6.71164 14.978 6.37585 14.978 5.96164V3C14.978 2.58579 15.3138 2.25 15.728 2.25Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.45605 2.25C8.87027 2.25 9.20605 2.58579 9.20605 3V5.96164C9.20605 6.37585 8.87027 6.71164 8.45605 6.71164C8.04184 6.71164 7.70605 6.37585 7.70605 5.96164V3C7.70605 2.58579 8.04184 2.25 8.45605 2.25Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.627 4.95074C5.54601 4.07702 6.8251 3.66992 8.28188 3.66992H15.902C17.362 3.66992 18.6419 4.0767 19.5595 4.95142C20.4829 5.83158 20.942 7.09251 20.9378 8.6002C20.9378 8.59998 20.9378 8.60042 20.9378 8.6002V11.6236C20.9378 12.0378 20.602 12.3736 20.1878 12.3736C19.7736 12.3736 19.4378 12.0378 19.4378 11.6236V8.59871V8.59656C19.4412 7.39781 19.0831 6.56959 18.5245 6.03717C17.9602 5.49918 17.0932 5.16992 15.902 5.16992H8.28188C7.09518 5.16992 6.22746 5.49886 5.66054 6.03785C5.09941 6.57133 4.73828 7.40051 4.73828 8.59871V16.7432C4.73828 17.9658 5.10167 18.816 5.66575 19.3627C6.23356 19.9131 7.09968 20.2479 8.28188 20.2479H10.5002C10.9144 20.2479 11.2502 20.5837 11.2502 20.9979C11.2502 21.4121 10.9144 21.7479 10.5002 21.7479H8.28188C6.8206 21.7479 5.53992 21.3297 4.62179 20.4398C3.69994 19.5463 3.23828 18.2692 3.23828 16.7432V8.59871C3.23828 7.09018 3.70221 5.82997 4.627 4.95074Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6099 14.8591L15.1534 18.6323C14.9942 18.8113 14.8948 19.0359 14.8689 19.2741L14.7804 20.0942C14.7704 20.1877 14.8519 20.2631 14.942 20.2481L15.7363 20.1149C15.7361 20.1149 15.7364 20.1149 15.7363 20.1149C15.9968 20.0709 16.2331 19.9406 16.4064 19.7463L16.4132 19.7386L19.837 16.0026L19.8395 15.9999C19.9685 15.8605 19.9589 15.6457 19.8219 15.5193L19.8208 15.5183L19.0906 14.8415C18.9532 14.7146 18.7382 14.722 18.6099 14.8591ZM17.5089 13.8404C18.1998 13.0953 19.3637 13.0507 20.1093 13.7405L20.8393 14.4171C20.8391 14.4169 20.8395 14.4173 20.8393 14.4171C21.5866 15.1075 21.6304 16.2714 20.9418 17.0172L17.5223 20.7487C17.12 21.198 16.5773 21.4943 15.9856 21.594L15.1901 21.7274C14.1185 21.9069 13.1726 21.0133 13.289 19.9335L13.3776 19.1132C13.4372 18.5628 13.6677 18.043 14.0382 17.6291L14.044 17.6226L17.5089 13.8404Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6915 14.7244C16.9844 14.4316 17.4593 14.4317 17.7521 14.7247L19.9957 16.9692C20.2886 17.2622 20.2885 17.7371 19.9955 18.0299C19.7025 18.3227 19.2277 18.3226 18.9348 18.0297L16.6912 15.7851C16.3984 15.4921 16.3985 15.0173 16.6915 14.7244Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.45605 13.2822C7.45605 12.868 7.79184 12.5322 8.20605 12.5322C8.62027 12.5322 8.95669 12.868 8.95669 13.2822C8.95669 13.6964 8.62091 14.0322 8.20669 14.0322C7.79248 14.0322 7.45605 13.6964 7.45605 13.2822Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.1338 13.2822C11.1338 12.868 11.4696 12.5322 11.8838 12.5322C12.298 12.5322 12.6344 12.868 12.6344 13.2822C12.6344 13.6964 12.2986 14.0322 11.8844 14.0322C11.4702 14.0322 11.1338 13.6964 11.1338 13.2822Z"
      fill="#64748B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.45605 16.6729C7.45605 16.2586 7.79184 15.9229 8.20605 15.9229C8.62027 15.9229 8.95669 16.2586 8.95669 16.6729C8.95669 17.0871 8.62091 17.4229 8.20669 17.4229C7.79248 17.4229 7.45605 17.0871 7.45605 16.6729Z"
      fill="#64748B"
    />
  </svg>
);
